import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** Gel is glossy blob voxels (gooey SDF surfaces that merge): every blob in a Gel world is gel. */
export const GEL_LIQUID = liquidKind('blob')

/**
 * A pour's sim delta, one event per commit; a whole press is one undo step. The coalescer
 * accumulates in place, so committing a long press costs O(cells), not O(events x cells).
 */
export const GEL_SETTLE = liquidSettleEvent('experience.gel.settle', GEL_LIQUID)

/** Reducer handlers for Gel (`experience.gel.*`). */
export const eventHandlers = GEL_SETTLE.handlers
